const u = navigator.userAgent;
// var appid="wx1a86bb7e7f5e7797";//保险服务助手
// var appid="wx04452e22173121e5";//梧桐树宝贝
// var appid="wx3571834748e0b0d6";//儿童险投保攻略
// var appid="wx9aa0e91be989a713";//蜡烛科技产品测试
// var appid="wx189d2299ad5e4503";//凤栖云服
// var appid="wx84c7f44ac41384e8";//小桐测评
const appid = ["wx84c7f44ac41384e8","wx1a86bb7e7f5e7797","wx84c7f44ac41384e8","wx1a86bb7e7f5e7797"]
const common = {
  env: API_CONFIG.ENV, //环境 0测试 1正式 2本地 3预发布
  appId: appid[API_CONFIG.ENV],
  // token:'eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE4OTc2MTQxNjIsInVzZXJpZCI6MTIwNjUwODM2MzAzOTQ4NTk1MiwiYm9keSI6IntcImlzTWVjaGFuXCI6dHJ1ZX0iLCJpYXQiOjE1ODIyNTQxNjIsImlzcyI6InhiYiJ9.l9Q0W2pBXJvs_m2O46IMbfYsR_ra8VUjh1KJBANrwxBo_Tyrig9iUXOB4oKWNtLAc03RY7tO2Yc8ryMWWJ41SA',
  // token:'eyJhbGciOiJIUzUxMiJ9.eyJleHAiOjE4OTkxNjYzMzMsInVzZXJpZCI6MTE0OTUyNTcxOTIzMjEyNjk3NiwiYm9keSI6IntcImlzTWVjaGFuXCI6dHJ1ZX0iLCJpYXQiOjE1ODM4MDYzMzMsImlzcyI6InhiYiJ9.n5jS9Zzpj-4fcRrsRNSO6ELRwL2qPJ0nlyqR7zP3esjV7BS_3uqOHvoIoz7YVkBQ5akLYto4YhcdjzSncVdSPw',
  isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
  isApp: u.indexOf('com.wts.fqyf') > -1,
  isOldApp: u.indexOf('wtsfqyf:') > -1,
  isNewApp: u.indexOf('com.wts.fqyf') > -1,
  isBDGJ: location.href.includes("/bdgj/"),
}
export default common;
